<template>
<div>
    <slot name="header-content"></slot>
    <slot name="main-content">
        <tip-tap v-model="content" />
    </slot>
    <slot name="footer-content"></slot>
</div>
</template>

<script>
import TipTap from "../../utils/TipTap2.vue";
export default {


    components: {
        'tip-tap': TipTap,
    },

    props: {
        value: {
            type: String,
            default: null
        },
    },

    computed: {
        content: {
            get: function () {
                return this.value;
            },
            set: function (newValue) {
                this.$emit('input', newValue)
            }
        }
    },

    mounted() {
        this.content = this.value
    },

    methods: {
        updateHtml(value) {
            this.content = value;
        }
    }
}
</script>

<style scoped>

</style>
